/* global grecaptcha */

import thumbDownIcon from '@SvgIcon/thumbsdown.svg'
import thumbUpIcon from '@SvgIcon/thumbsup.svg'

import $ from 'jquery'
import Vue from 'vue'
import 'jarallax/dist/jarallax'
import captchaManager from '../../shared/captcha'
import svgIconHtml from '../../shared/svgIconHtml'

import '../../../scss/app/page.scss'

const FeedbackComponent = Vue.extend({
  // language=HTML
  template: `
    <div class="feedback-form">
      <div v-if="!thanks">
        <div v-if="!formVisible" class="form-group">
          <label>Was this page helpful?</label>
          <button type="button" class="hollow button helpful" @click="markYes">
            ${svgIconHtml(thumbUpIcon)}
            <span class="ib">Yes</span>
          </button>
          <button type="button" class="hollow button unhelpful" @click="markNo">
            ${svgIconHtml(thumbDownIcon)}
            <span class="ib">No</span>
          </button>
        </div>
        <div v-else>
          <p v-if="isHelpful">
            <b>Great!</b> <br>
            Do you have any suggestions?
          </p>
          <p v-else>
            How can we improve it?
          </p>
          <div class="form-group">
            <textarea
              aria-label="How can we improve it?"
              rows="3" cols="30" maxlength="1000"
              v-focus
              v-model="feedback"></textarea>
          </div>
          <div class="form-group">
            <label>If you would like to discuss, please enter your email address:</label>
            <input
              type="email"
              aria-label="Your email address"
              maxlength="255"
              v-model="email" />
          </div>
          <div class="form-group" v-if="showCaptchaElement">
            <div class="g-recaptcha"></div>
          </div>
          <div class="alert callout" role="alert" v-if="error">{{ error }}</div>
          <button type="button" class="button" :disabled="submitting" @click="submitFeedback">Submit</button>
        </div>
      </div>
      <div v-else>
        <p>Thanks for your feedback!</p>
      </div>
    </div>
  `,
  props: {
    feedbackUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: '',
      feedback: '',
      email: '',
      isHelpful: true,
      formVisible: false,
      submitting: false,
      thanks: false,
    }
  },
  computed: {
    showCaptchaElement() {
      return captchaManager.canRender()
    },
  },
  methods: {
    markYes() {
      this.error = ''
      this.isHelpful = true
      this.formVisible = true
    },
    markNo() {
      this.error = ''
      this.isHelpful = false
      this.formVisible = true
    },
    async submitFeedback() {
      if (this.submitting) {
        return
      }

      this.error = ''
      this.submitting = true

      try {
        const recaptchaToken = await captchaManager.getToken('submit', { container: this.$el })
        if (captchaManager.hasDriver() && !recaptchaToken) {
          this.error = 'Captcha challenge failed. Please try again.'
          return
        }

        const response = await $.ajax({
          type: 'POST',
          url: this.feedbackUrl,
          data: {
            recaptchaToken,
            helpful: this.isHelpful ? 1 : 0,
            feedback: this.feedback,
            email: this.email,
            url: window.location.pathname,
            ua: navigator.userAgent,
          },
        })

        if ('error' in response) {
          this.error =
            response.error === 'Invalid captcha'
              ? 'Captcha challenge failed. Please try again.'
              : 'Sorry, there was a problem sending your feedback. Please try again.'
          return
        }

        this.thanks = true
      } catch {
        this.error = 'Sorry, there was a problem sending your feedback. Please try again.'
      } finally {
        this.submitting = false
      }
    },
  },
})

if (document.querySelector('.feedback-form')) {
  new Vue({
    el: '.feedback-form',
    render(h) {
      return h(FeedbackComponent, {
        props: {
          feedbackUrl: this.$el.attributes['data-feedback'].value,
        },
      })
    },
  })
}
